import { render, staticRenderFns } from "./validationMFA.vue?vue&type=template&id=961ebd94&scoped=true&"
import script from "./validationMFA.vue?vue&type=script&lang=js&"
export * from "./validationMFA.vue?vue&type=script&lang=js&"
import style0 from "./validationMFA.vue?vue&type=style&index=0&id=961ebd94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961ebd94",
  null
  
)

export default component.exports